import { ILicenseConsumptionInfo } from '../types/ILicenseConsumptionInfo';
import { Request } from './Request';

export class GetSiteLicensingConsumptionInfoRequest extends Request<{}, ILicenseConsumptionInfo> {
  constructor() {
    super('getSiteLicensingConsumptionInfo', {});
  }
}
